import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const LeavesUrl = `${Base_Url}/EmailTemplate`;

export const GetEmailTemplateList = async (params) => {
  const res = await postApiWithAuthorization(
    `${LeavesUrl}/GetEmailTemplateList`,
    params
  );
  return res;
};

export const AddUpdateEmailTemplate = async (params) => {
  const res = await postApiWithAuthorization(
    `${LeavesUrl}/AddUpdateEmailTemplate?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetEmailTemplateModel = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${LeavesUrl}/GetEmailTemplateModel?ModuleName=${ModuleName}&EmailTemplateKeyID=${KeyID}&AdminKeyID=${AdminKeyID}`
  );
  return res;
};

export const ChangeEmailTemplateStatus = async (
  ModuleName,
  KeyID,
  AdminKeyID
) => {
  const res = await getApiWithAuthorization(
    `${LeavesUrl}/ChangeEmailTemplateStatus?ModuleName=${ModuleName}&EmailTemplateKeyID=${KeyID}&AdminKeyID=${AdminKeyID}`
  );
  return res;
};

export const DeleteEmailTemplate = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${LeavesUrl}/DeleteEmailTemplate?ModuleName=${ModuleName}&EmailTemplateKeyID=${KeyID}&AdminKeyID=${AdminKeyID}`
  );
  return res;
};
